<div class="monthpicker__mobile-header">
  <div class="monthpicker__mobile-title-container">
    <button aria-label="Close" type="button" (click)="close()"><span class="fa-arrow-flight"></span></button>
    <span *ngIf="state.title">{{ state.title }}</span>
  </div>
  <div class="monthpicker__mobile-input-container">
    <input #input type="text" [placeholder]="state.mask" (input)="inputChange()" [disabled]="state.disabled" />
    <span class='fa-calendar'></span>
  </div>
</div>
<div #viewportContainer class="monthpicker__mobile-body" (click)="onClick($event)">
  <cdk-virtual-scroll-viewport *ngIf="showScrollViewport" [itemSize]="itemSize" [minBufferPx]="minBufferPx"
                               [maxBufferPx]="maxBufferPx">
    <ng-template cdkVirtualFor let-year [cdkVirtualForOf]="years" [cdkVirtualForTrackBy]="trackByYear">
      <div class="monthpicker__mobile-year" [style.height]="itemSize ? itemSize + 'px' : 'auto'">
        <span>{{ year }}</span>
        <div class="row m-0" [attr.data-year]="year">
          <ng-container *ngIf="year === this.state.selected.year || year === getToday.year; else generalMonths"
                        [ngTemplateOutlet]="markedMonths"
                        [ngTemplateOutletContext]="{ selected: year === this.state.selected.year, today: year === getToday.year }">
          </ng-container>
        </div>
      </div>
    </ng-template>
  </cdk-virtual-scroll-viewport>
</div>
<div class="monthpicker__mobile-footer">
  <button (click)="reset()" type="button" class="btn btn-outline-primary me-2">{{ state.resetButton }}</button>
  <button (click)="done()" type="button" class="btn btn-primary me-3">{{ state.doneButton }}</button>
</div>
<ng-template #generalMonths>
  <div *ngFor="let month of state.monthNames; let i = index" class="col-2 monthpicker__month" [attr.data-month]="i + 1">
    <span>{{ month }}</span>
  </div>
</ng-template>
<ng-template #markedMonths let-selected="selected" let-today="today">
  <div *ngFor="let month of state.monthNames; let i = index" class="col-2 monthpicker__month" [attr.data-month]="i + 1"
       [class.selected]="selected && i === this.state.selected.month - 1"
       [class.today]="today && i === getToday.month - 1">
    <span>{{ month }}</span>
  </div>
</ng-template>
